import React, { Component } from 'react';
import PricingCard from './PricingCard';
import ReactModal from 'react-modal';
import { connect, ReactReduxContext } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import * as ROUTES from '../../../constants/routes';
import PricingModal from './PricingModal';
import { openNewAuthChangesModal } from '../../../store/actions/authActions';
import AuthWrapper from '../../auth/forms/AuthWrapper';

const ViewButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }

        &:active {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

class ProductCard extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }



    render() {
        const fontStyle = {
            fontSize: '14px',
            height: '65px',
            maxHeight: '70px'
        }

        const schemeList = ['month', 'year', 'lifetime', 'day'];
        const { listOfProducts, product, isSignedIn, modalStyles, themeColors, commons } = this.props;
        const { companyMembersLimit, externalProjectMembersLimit, internalProjectMembersLimit, itemDescription, itemName, price, scheme, featureList, projectTagLimit } = product;

        const schemeName = schemeList[scheme];

        return (
            <React.Fragment>
                <ul className="list-group list-group-flush" style={{}}>
                    <li className="list-group-item pull-center dropdown show" style={fontStyle}>
                        <span className="pricinghinttext">Tag limit:</span>
                        <span className="btn btn-flat btn-sm dropdown-toggle border-bottom" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {product ? product.tagLimit : 'loading...'}
                        </span>
                        <div className="dropdown-menu border" aria-labelledby="dropdownMenuLink">
                            {[...listOfProducts].map((eachProduct, i) => {
                                return <span role="button" className="dropdown-item" key={i} onClick={() => { this.props.handleProductSelect(eachProduct) }} data-toggle="tooltip" data-placement="top" title={eachProduct.tagLimit}>
                                    {eachProduct.tagLimit}
                                </span>
                            })}
                        </div>
                        {/* <p style={{ fontSize: '12px', color: '#141414', paddingTop: '5px', paddingBottom: '3px' }}>(View more option using dropdown)</p> */}
                    </li>
                    <li className="list-group-item pull-center" style={fontStyle}><span className="pricinghinttext">Project tag limit:</span>{projectTagLimit === '-1' ? `${commons.uunlimited}` : projectTagLimit}</li>
                    <li className="list-group-item pull-center" style={fontStyle}><span className="pricinghinttext">Company members:</span>{companyMembersLimit === '-1' ? `${commons.uunlimited}` : companyMembersLimit}</li>
                    <li className="list-group-item pull-center" style={fontStyle}><span className="pricinghinttext">Internal {commons.project} members:</span>{internalProjectMembersLimit === '-1' ? `${commons.uunlimited}` : internalProjectMembersLimit}</li>
                    <li className="list-group-item pull-center" style={fontStyle}><span className="pricinghinttext">External {commons.project} members:</span>{externalProjectMembersLimit === '-1' ? `${commons.uunlimited}` : externalProjectMembersLimit}</li>
                </ul>

                {/* <h3><span>${price}</span><span style={{ color: "gray" }}> /{schemeName}</span></h3> */}


                {/* PAYMENT SELECTION MODAL */}

            </React.Fragment>
        );
    }
}

class TierCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productInFocus: null,
            showPaymentModal: false,
            toggle: false,
        };
    }

    componentDidMount() {
        const { listOfProducts } = this.props;
        this.setState({
            productInFocus: listOfProducts[0],
        })
    }

    handleProductSelect = (selectedProduct) => {
        this.setState({
            productInFocus: selectedProduct,
        })
    }
    /// README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.setState({ showPaymentModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showPaymentModal: false });
    }

    render() {
        const schemeList = ['month', 'year', 'lifetime', 'day'];
        const featureStyle = {
            fontSize: "14px",
            lineHeight: "12px",
        };
        const { productInFocus } = this.state;
        if (!productInFocus) {
            return (
                <React.Fragment />
            )
        }
        const { listOfProducts, tier, isSignedIn, modalStyles, themeColors, commons, storeInfo } = this.props;
        const schemeName = schemeList[productInFocus ? productInFocus.scheme : ''];
        console.log(productInFocus.price)
        const discountPrice = Number(productInFocus.featured === true ? (((100 - storeInfo.discountPercentage) / 100) * productInFocus.price) : productInFocus.price).toFixed(0);
        // const priceSaveMessage = productInFocus.featured === true ? `${storeInfo.priceSaveMessage} ${commons.priceIn}${Number(productInFocus.price - discountPrice).toFixed(0)}` : ""
        const priceSaveMessage =  productInFocus.featured === true ?`${storeInfo.priceSaveMessage} ${commons.priceIn}${productInFocus.price} `:""
        // const schemeName = schemeList[tier.tierPeriod];
        const relevantButton = isSignedIn ? <button className="btn btn-flat my-3" onClick={() => this.handleOpenModal()}>Subscribe now</button> :
            // <Link to={ROUTES.SIGN_UP} className="btn btn-flat my-3">Sign up for free</Link>
            <button className="btn btn-flat my-3" onClick={() => { this.setState({ toggle: true }); this.props.openNewAuthChangesModal() }} >Sign up for free</button>

        return (
            <div className="card h-100" style={{ borderRadius: '0px' }}>
                {/* {[...listOfProducts].map((eachProduct) => {
                    return <button key={eachProduct.productId} onClick={() => { this.handleProductSelect(eachProduct) }}>{eachProduct.itemName}</button>
                })} */}

                <div className="card-header" style={{ height: '150px' }}>
                    <h6 className="align-self-center"><b>{tier.tierName}</b></h6>
                    <div className="align-self-center"><span style={{ fontSize: '50px', fontWeight: 'bold' }}> {commons.priceIn}{discountPrice}</span><span style={{ color: "gray", fontSize: '14px' }}> /{schemeName}</span><span style={{ fontSize: '30px', color: 'grey', marginLeft: '5px' }}>{productInFocus ? productInFocus.featured === true ? '*' : <React.Fragment /> : <React.Fragment />}</span></div>
                    <div className="align-self-center"><span style={{ color: "gray", fontSize: '14px',textDecoration:'line-through' }}> {priceSaveMessage}</span></div>
                </div>

                <div className="" >
                    {productInFocus ? <ProductCard commons={commons} themeColors={themeColors} listOfProducts={listOfProducts} product={productInFocus} handleProductSelect={this.handleProductSelect} isSignedIn={isSignedIn} modalStyles={modalStyles} /> : <p>Loading...</p>}
                </div>
                <div className="card-footer mt-auto" style={{ backgroundColor: "white", borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px', height: '100px', maxHeight: '200px' }}>
                    <ViewButton themeColors={themeColors}>
                        {relevantButton}
                    </ViewButton>
                </div>
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.toggle && !isSignedIn}
                    onRequestClose={() => { this.setState({ toggle: false }) }}
                    contentLabel="See controls"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.setState({ toggle: false }) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <AuthWrapper />
                </ReactModal>
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showPaymentModal}
                    onRequestClose={() => { this.handleCloseModal() }}
                    contentLabel="See all payment methods"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <PricingModal priceCard={productInFocus} storeInfo={storeInfo} />
                </ReactModal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        isSignedIn: !state.firebase.auth.isEmpty,
        modalStyles: state.appControl.modalStyles,
        commons: state.commons,
        storeInfo: state.firestore.data.StoreInfo,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        openNewAuthChangesModal: () => dispatch(openNewAuthChangesModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TierCard);